package org.catharsis.spendtel.feature.data

import kotlinx.datetime.TimeZone
import kotlinx.datetime.number
import kotlinx.datetime.toLocalDateTime
import kotlin.time.ExperimentalTime
import kotlin.time.Instant

@OptIn(ExperimentalTime::class)
fun formatReportDate(epochMillis: Long): String {
    if (epochMillis <= 0L) return "New report"

    val localDate = Instant.fromEpochMilliseconds(epochMillis)
        .toLocalDateTime(TimeZone.currentSystemDefault())
        .date

    val month = reportMonthNames.getOrElse(localDate.month.number - 1) { "???" }
    return "$month ${localDate.day}, ${localDate.year}"
}

private val reportMonthNames = listOf(
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
)
